/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgAiControllerFindAllAdminParamsGen,
  ThgAiControllerGetParamsGen,
  ThgAiControllerReadRegistrationResultParamsGen,
  ThgAiControllerSummarizeParamsGen,
  ThgGooglePlaceDtoGen,
  ThgHasAddressWithGeoViewModelGen,
  ThgImageAnalysisAltDtoGen,
  ThgImageAnalysisCostDtoGen,
  ThgLocationControllerFromGeoParamsGen,
  ThgLocationControllerSearchParamsGen,
  ThgOpenAiAnalysisCostViewModelGen,
  ThgOpenAiImageAnalysisAltViewModelGen,
  ThgOpenAiPartnerViewModelGen,
  ThgOpenAiRegistrationRecognitionViewModelGen,
  ThgOpenAiReportFromMessageViewModelGen,
  ThgOpenAiReportSummaryViewModelGen,
  ThgPageViewModelGen,
  ThgTranslationInputDtoGen,
  ThgTranslationInputViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Ai<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ai
   * @name LocationControllerFromGeo
   * @summary (AI Location - READ) Reverse geocode by lat/lng
   * @request GET:/partner/{partnerId}/ai/location/from-geo
   * @secure
   * @response `200` `(ThgHasAddressWithGeoViewModelGen)[]` The address components wrapped in has-address viewmodel
   */
  locationControllerFromGeo = (
    { partnerId, ...query }: ThgLocationControllerFromGeoParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgHasAddressWithGeoViewModelGen[], any>({
      path: `/partner/${partnerId}/ai/location/from-geo`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name LocationControllerSearch
   * @summary (AI Location - READ) Get a result
   * @request GET:/partner/{partnerId}/ai/location/{search}
   * @secure
   * @response `200` `(ThgGooglePlaceDtoGen)[]` The places
   */
  locationControllerSearch = (
    { partnerId, search, ...query }: ThgLocationControllerSearchParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgGooglePlaceDtoGen[], any>({
      path: `/partner/${partnerId}/ai/location/${search}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name LocationControllerGetOne
   * @summary (AI Location - READ) Get a result
   * @request GET:/partner/{partnerId}/ai/location/{id}/byId
   * @secure
   * @response `200` `ThgGooglePlaceDtoGen` The place
   */
  locationControllerGetOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgGooglePlaceDtoGen, any>({
      path: `/partner/${partnerId}/ai/location/${id}/byId`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerFindAllAdmin
   * @summary (ADMIN) Get all ai results across partners
   * @request GET:/ai
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgOpenAiPartnerViewModelGen)[] })`
   */
  aiControllerFindAllAdmin = (query: ThgAiControllerFindAllAdminParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgOpenAiPartnerViewModelGen[] }, any>({
      path: `/ai`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerGet
   * @summary (AI - READ) Get all ai results
   * @request GET:/partner/{partnerId}/ai
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgOpenAiPartnerViewModelGen)[] })`
   */
  aiControllerGet = ({ partnerId, ...query }: ThgAiControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgOpenAiPartnerViewModelGen[] }, any>({
      path: `/partner/${partnerId}/ai`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerGetOne
   * @summary (AI - READ) Get a result
   * @request GET:/partner/{partnerId}/ai/{id}
   * @secure
   * @response `200` `ThgOpenAiPartnerViewModelGen` The ticket
   */
  aiControllerGetOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgOpenAiPartnerViewModelGen, any>({
      path: `/partner/${partnerId}/ai/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerReadRegistrationResult
   * @summary Get registration result for image
   * @request GET:/partner/{partnerId}/ai/image/{imageId}/registration-recognition
   * @secure
   * @response `200` `ThgOpenAiRegistrationRecognitionViewModelGen` The registration result
   */
  aiControllerReadRegistrationResult = (
    { partnerId, imageId, ...query }: ThgAiControllerReadRegistrationResultParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgOpenAiRegistrationRecognitionViewModelGen, any>({
      path: `/partner/${partnerId}/ai/image/${imageId}/registration-recognition`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerSummarize
   * @summary Get summary of report
   * @request GET:/partner/{partnerId}/ai/report/{reportId}/report-summarization
   * @secure
   * @response `200` `ThgOpenAiReportSummaryViewModelGen` The summary of the report
   */
  aiControllerSummarize = (
    { partnerId, reportId, ...query }: ThgAiControllerSummarizeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgOpenAiReportSummaryViewModelGen, any>({
      path: `/partner/${partnerId}/ai/report/${reportId}/report-summarization`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerTranslate
   * @summary Get translation
   * @request POST:/ai/translation/{language}
   * @secure
   * @response `201` `ThgTranslationInputViewModelGen` The translated input
   */
  aiControllerTranslate = (
    language:
      | "af"
      | "sq"
      | "ar"
      | "hy"
      | "eu"
      | "be"
      | "bn"
      | "bg"
      | "ca"
      | "zh"
      | "hr"
      | "cs"
      | "da"
      | "nl"
      | "en"
      | "eo"
      | "et"
      | "fi"
      | "fr"
      | "gl"
      | "ka"
      | "de"
      | "de_ch"
      | "el"
      | "gu"
      | "he"
      | "hi"
      | "hu"
      | "is"
      | "id"
      | "ga"
      | "it"
      | "ja"
      | "jv"
      | "kn"
      | "kk"
      | "ko"
      | "ku"
      | "ky"
      | "lv"
      | "lt"
      | "lb"
      | "mk"
      | "mg"
      | "ms"
      | "ml"
      | "mt"
      | "mi"
      | "mr"
      | "mn"
      | "ne"
      | "no"
      | "or"
      | "ps"
      | "fa"
      | "pl"
      | "pt"
      | "pa"
      | "ro"
      | "ru"
      | "sm"
      | "gd"
      | "sr"
      | "si"
      | "sk"
      | "sl"
      | "es"
      | "su"
      | "sw"
      | "sv"
      | "tl"
      | "tg"
      | "ta"
      | "te"
      | "th"
      | "bo"
      | "tr"
      | "uk"
      | "ur"
      | "uz"
      | "vi"
      | "cy"
      | "xh"
      | "yi"
      | "yo"
      | "zu",
    data: ThgTranslationInputDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgTranslationInputViewModelGen, any>({
      path: `/ai/translation/${language}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerTranslateAsPartner
   * @summary Get translation
   * @request POST:/partner/{partnerId}/ai/translation/{language}
   * @secure
   * @response `201` `ThgTranslationInputViewModelGen` The translated input
   */
  aiControllerTranslateAsPartner = (
    partnerId: string,
    language:
      | "af"
      | "sq"
      | "ar"
      | "hy"
      | "eu"
      | "be"
      | "bn"
      | "bg"
      | "ca"
      | "zh"
      | "hr"
      | "cs"
      | "da"
      | "nl"
      | "en"
      | "eo"
      | "et"
      | "fi"
      | "fr"
      | "gl"
      | "ka"
      | "de"
      | "de_ch"
      | "el"
      | "gu"
      | "he"
      | "hi"
      | "hu"
      | "is"
      | "id"
      | "ga"
      | "it"
      | "ja"
      | "jv"
      | "kn"
      | "kk"
      | "ko"
      | "ku"
      | "ky"
      | "lv"
      | "lt"
      | "lb"
      | "mk"
      | "mg"
      | "ms"
      | "ml"
      | "mt"
      | "mi"
      | "mr"
      | "mn"
      | "ne"
      | "no"
      | "or"
      | "ps"
      | "fa"
      | "pl"
      | "pt"
      | "pa"
      | "ro"
      | "ru"
      | "sm"
      | "gd"
      | "sr"
      | "si"
      | "sk"
      | "sl"
      | "es"
      | "su"
      | "sw"
      | "sv"
      | "tl"
      | "tg"
      | "ta"
      | "te"
      | "th"
      | "bo"
      | "tr"
      | "uk"
      | "ur"
      | "uz"
      | "vi"
      | "cy"
      | "xh"
      | "yi"
      | "yo"
      | "zu",
    data: ThgTranslationInputDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgTranslationInputViewModelGen, any>({
      path: `/partner/${partnerId}/ai/translation/${language}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerGenerateAltTextForImages
   * @summary Derive information from an image depending on context
   * @request POST:/partner/{partnerId}/ai/image-analysis/alt
   * @secure
   * @response `201` `ThgOpenAiImageAnalysisAltViewModelGen` Analysis result.
   */
  aiControllerGenerateAltTextForImages = (
    partnerId: string,
    data: ThgImageAnalysisAltDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgOpenAiImageAnalysisAltViewModelGen, any>({
      path: `/partner/${partnerId}/ai/image-analysis/alt`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerAnalyzeCostForImages
   * @summary Derive information from an image depending on context
   * @request POST:/partner/{partnerId}/ai/image-analysis/cost
   * @secure
   * @response `201` `ThgOpenAiAnalysisCostViewModelGen` Analysis result.
   */
  aiControllerAnalyzeCostForImages = (
    partnerId: string,
    data: ThgImageAnalysisCostDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgOpenAiAnalysisCostViewModelGen, any>({
      path: `/partner/${partnerId}/ai/image-analysis/cost`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerAnalyzeCostForDocument
   * @summary Derive cost information from a document depending on context
   * @request POST:/partner/{partnerId}/ai/document/{documentId}/cost
   * @secure
   * @response `201` `ThgOpenAiAnalysisCostViewModelGen` Analysis result.
   */
  aiControllerAnalyzeCostForDocument = (partnerId: string, documentId: string, params: RequestParams = {}) =>
    this.http.request<ThgOpenAiAnalysisCostViewModelGen, any>({
      path: `/partner/${partnerId}/ai/document/${documentId}/cost`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags ai
   * @name AiControllerGetReportFromMessage
   * @summary Derive report information from a message depending on context
   * @request POST:/partner/{partnerId}/ai/message/{messageId}/report
   * @secure
   * @response `201` `ThgOpenAiReportFromMessageViewModelGen` Analysis result.
   */
  aiControllerGetReportFromMessage = (partnerId: string, messageId: string, params: RequestParams = {}) =>
    this.http.request<ThgOpenAiReportFromMessageViewModelGen, any>({
      path: `/partner/${partnerId}/ai/message/${messageId}/report`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
}
